import { Context } from '@nuxt/types';

export default async function (context: Context) {
  const { redirect, app } = context;

  if (!(await app.$auth.isLoggedIn())) {
    redirect('/');
  }
}
